import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { OurTeamDetailsComponent } from './our-team-details.component';
import { OurTeamDetailsRoutingoModule } from './our-team-details-routing.module';
@NgModule({
  imports: [
    OurTeamDetailsRoutingoModule,
    HttpClientModule,
    CommonModule,
    LoadingModule
  ],
  declarations: [OurTeamDetailsComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class OurTeamDetailsModule { }
